import { PaginationState } from "@tanstack/react-table"
import { Dispatch, SetStateAction } from "react"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { ProductTypeResponseDto } from "~/gen/api/types"

import { useColumns } from "./columns"

type Props = {
  productTypes: ProductTypeResponseDto[]
  total: number
  pagination: PaginationState
  setPagination: Dispatch<SetStateAction<PaginationState>>
}

export function ProductTypesTable({
  productTypes,
  total,
  pagination,
  setPagination,
}: Props) {
  const columns = useColumns()

  const table = useCustomReactTable({
    data: productTypes,
    columns,
    state: {
      pagination,
    },
    pageCount: Math.ceil(total / pagination.pageSize),
    manualPagination: true,
    onPaginationChange: setPagination,
  })

  return <CustomTable table={table} manualPaginationCount={total} />
}
